import { defineStore } from 'pinia'
import axios from 'axios'
import {reactive,ref} from 'vue'
import Swal from 'sweetalert2'
import { useLocalizationStore } from './LocalizationStore.js';
import { useRoute, useRouter } from 'vue-router'

export const useFamilyStore = defineStore('FamilyStore', {
    state: () => {
        return {
            family: reactive({}),
            familyName: ref(null),
            localizationStore: useLocalizationStore(),
            route: useRoute(),
            router: useRouter(),
            isFamilyFetched: ref(false)
        }
    },
    actions: {
        createNewFamily() {
            const $this = this;
            if($this.familyName !=  "") {
                const route = this.router.resolve(
                    {
                        name: 'family-index',
                    }
                );
                axios.post(
                    route.href,
                    {
                        name: $this.familyName
                    }
                ).then(({data})=>{
                    if(data.error != true){
                        toastr.success(data.message,'Family Success');
                        $this.fetchFamily();
                    }else{
                        toastr.error(data.message,'Family error');
                    }
                });
            }
        },
        async fetchFamily() {
            try {
                const $this = this;
                const route = this.router.resolve(
                    {
                        name: 'family-get',
                    }
                ); 
                this.family = await axios.post(route.href)
                .then(function (response) {
                    $this.isFamilyFetched = true;
                    return response.data.data;
                });
            } catch (error) {
            }
        },
        deleteFamilyMember(routeName, params) {
            const $this = this;
            Swal.fire({
                title: this.localizationStore.translate('are.you.sure'),
                icon: 'warning',
                text: this.localizationStore.translate('not.revert'),
                showCancelButton: true,
                confirmButtonText: 'Yes!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.router.resolve(
                        {
                            name: routeName,
                            params: params
                        }
                    );                    
                    axios.delete(route.href).then(({data})=>{
                        if(data.error != true){
                            toastr.success(`${data.message}`,'Update Success');
                            $this.fetchFamily();
                        }else{
                            return toastr.error(`${data.message}`,'Update Error');
                        }
                    }).catch(error=>{
                        let errors = $this.getError(error)
                        for (const key in errors) {
                            if (Object.hasOwnProperty.call(errors, key)) {
                                const element = errors[key];
                                return toastr.error(`${element}`,'Invite Error');
                            }
                        }
                    })
                }
            });
        },
        leaveFamily(params) {
            let $this = this;
            Swal.fire({
                title: this.localizationStore.translate('are.you.sure'),
                icon: 'warning',
                text: this.localizationStore.translate('family.member.leave.label'),
                showCancelButton: true,
                confirmButtonText: 'Yes, leave family!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.router.resolve(
                        {
                            name: 'family-member-delete',
                            params: params
                        }
                    );  
                    axios.delete(route.href).then(({data})=>{
                        if(data.error != true){
                            toastr.success($this.localizationStore.translate('left.family'),'Family Success');
                            $this.fetchFamily();
                        }else{
                            toastr.error(`${data.message}`,'Family Error');
                        }
                    }).catch(error=>{
                        let errors = $this.getError(error)
                        for (const key in errors) {
                            if (Object.hasOwnProperty.call(errors, key)) {
                                const element = errors[key];
                                return toastr.error(`${element}`,'Family Error');
                            }
                        }
                    })
                }
            });
        },
        resendFamilyInvite(inviteId){
            const $this = this;
            Swal.fire({
                title: this.localizationStore.translate('are.you.sure'),
                icon: 'warning',
                text: this.localizationStore.translate('family.member.resend.invite'),
                showCancelButton: true,
                confirmButtonText: 'Yes, Resend!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.router.resolve(
                        {
                            name: 'family-member-resend-email',
                            params: {
                                invite: inviteId
                            }
                        }
                    );
                    axios.get(route.href).then(({data})=>{
                        if(data.error != true){
                            toastr.success(data.message,'Invite Success');
                            $this.fetchFamily()
                        }else{
                            toastr.error(`${data.message}`,'Invite Error');
                        }
                    }).catch(error=>{
                        let errors = $this.getError(error)
                        for (const key in errors) {
                            if (Object.hasOwnProperty.call(errors, key)) {
                                const element = errors[key];
                                return toastr.error(`${element}`,'Invite Error');
                            }
                        }
                    })
                }
            });
        },
        deleteFamily() {
            const $this = this;
            Swal.fire({
                title: this.localizationStore.translate('are.you.sure'),
                icon: 'warning',
                text: this.localizationStore.translate('not.revert'),
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    const route = $this.router.resolve(
                        {
                            name: 'family-delete',
                            params: {
                                family: $this.family.family.id
                            }
                        }
                    );
                    axios.post(route.href).then(({data})=>{
                        if(data.error != true){
                            toastr.success(`${data.message}`,'Delete Success');
                            $this.fetchFamily()
                        }else{
                            return toastr.error(`${data.message}`,'Delete Error');
                        }
                    }).catch(error=>{
                        let errors = $this.getError(error)
                        for (const key in errors) {
                            if (Object.hasOwnProperty.call(errors, key)) {
                                const element = errors[key];
                                return toastr.error(`${element}`,'Delete Error');
                            }
                        }
                    })
                }
            });
        },
        getError(error){
            const errorMsg = "";
            if (!error.response) {
                return errorMsg;
            }
            if (error.response.data && error.response.data.errors) {
                return error.response.data.errors;
            }
            return errorMsg;
        },
    }
})
